import {api} from '../../../system/api';

export default {
    updateInfoUser: (data) => api.post("/auth/user", data)
};
